import Money from "../Money";
import Stepper from "../Stepper";
import styles from "./StepperGroup.module.css";

interface StepperGroupValue {
  [value: string]: number;
}

type StepperGroupProps = {
  currencyCode: string;
  max: number;
  value: StepperGroupValue;
  isPrivateExclusive: boolean;
  onChange: (id: string, value: number) => void;
  datalist: Array<{
    id: string;
    label: string;
    description: string | null;
    max: number;
    min: number;
    vegetarian: boolean;
    price: {
      amount: number;
    };
  }>;
};

const add = (a: number, b: number) => a + b;
const getTotal = (value: StepperGroupValue) =>
  Object.values(value).reduce(add, 0);

// @todo move render label logic out of the component

export default function StepperGroup({
  currencyCode,
  datalist,
  isPrivateExclusive,
  max,
  onChange,
  value,
}: StepperGroupProps) {
  const total = getTotal(value);
  const seatsLeft = max - total;

  return (
    <ol>
      {datalist.map((item, index) => {
        const val = value[item.id];
        const max = Math.min(item.max, val + seatsLeft);
        const disabled = val === 0 && val === max;

        return (
          <li key={index} className={styles.StepperGroupItem}>
            <div className={styles.StepperGroupLabel}>
              <label>
                <b>
                  {(!!item.price.amount || !isPrivateExclusive) && (
                    <Money amount={item.price.amount} currency={currencyCode} />
                  )}
                </b>
                <div className={styles.StepperGroupType}>
                  {item.label}{" "}
                  {item.vegetarian && (
                    <span style={{ color: "green", fontWeight: "bolder" }}>
                      (For Vegetarians)
                    </span>
                  )}
                </div>
              </label>
              {item.description && (
                <div className={styles.StepperGroupDesc}>
                  <small style={{ whiteSpace: "pre-wrap" }}>
                    {item.description}
                  </small>
                </div>
              )}
            </div>
            <div>
              <Stepper
                min={item.min}
                max={max}
                disabled={disabled}
                value={val}
                onChange={(value) => onChange(item.id, value)}
              />
            </div>
          </li>
        );
      })}
    </ol>
  );
}
